import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('showPeriodicEnabledOptions', function (choice) {
    var optionState = getStore().currentState;
    optionState.periodicReplyEnabled = choice;
});
//# sourceMappingURL=showPeriodicEnabledOptions.js.map